var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFooterE(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 237,
    height: 215,
    viewBox: "0 0 237 215",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M97.571 77.7995C70.4092 77.7995 55.7119 94.3473 47.4272 108.955C42.6309 117.712 41.7588 126.477 40.8867 134.593H154.255C153.383 126.477 152.511 117.712 147.715 108.955C139.43 94.3473 124.44 77.7995 97.571 77.7995Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.581 158.937H41.2016C44.0283 194.621 65.9352 215.746 104.111 215.746C128.965 215.746 140.512 202.915 157.517 190.263L179.537 203.159C162.968 219.423 139.865 244.151 103.239 244.151C46.5543 244.151 9.49142 204.279 9.49142 147.802C9.49142 96.2028 42.5322 51.8103 97.0364 51.8103C152.413 51.8103 184.581 95.9756 184.581 143.363V158.937ZM199.617 134.59H236.477C229.327 53.4334 170.117 0 98.1265 0C21.317 0 -40.9531 67.2868 -40.9531 150.196C-40.9531 233.122 21.317 297 98.1265 297C170.117 297 229.327 240.093 236.477 158.937H199.617V134.59Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterE);
export default __webpack_public_path__ + "static/media/footer-e.623dbcf62900263d50848482616ed9c8.svg";
export { ForwardRef as ReactComponent };